module.exports = __webpack_public_path__ + "assets/img/pan3.06b503ed.svg";